module.exports = __webpack_public_path__ + "img/main-circle-3.54e5a81b.png";